// src/components/Header.jsx
import React, { useState,useEffect } from 'react';
import './Header.css'
import { Link } from 'react-router-dom';
import  MenuSerive  from '../services/menuService';
import MenuItem from './MenuItem';
import ApplicationMenuItem from './ApplicationMenuItem';
import menuService from '../services/menuService';
import { useNavigate } from 'react-router-dom';



const items = ['Apple', 'Banana', 'Cherry', 'Date', 'Grapes', 'Mango', 'Orange'];

  
const Header = () => {
    const navigate = useNavigate();

    const [activeMenu, setActiveMenu] = useState(null);
    const [menuData, setMenuData] = useState([]);
    const [applicationData, setApplicationData] = useState([]);
      const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
const [isMobileMenuOpen, setIsMobileMenuOpen] = useState('menu-wrapper');



  useEffect(() => {
    const loadMenu = async () => {
      const data = await MenuSerive.fetchMenu();
      setMenuData(Array.isArray(data) ? data : []);
    };
    
    loadMenu();
 const loadApplications = async () => {
      const data = await MenuSerive.fetchApplications();
      setApplicationData(Array.isArray(data) ? data : []);
    };
    loadApplications();
  }, []);

useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (query.length >= 2) {
        getResults(query);
      } else {
        setResults([]);
      }
    }, 300); // debounce input

    return () => clearTimeout(delayDebounce);
  }, [query]);

  const getResults = async (q) => {
    setIsLoading(true);
    const suggestions =await menuService.fetchSearchedProduct(q);
    setResults(suggestions);
    setIsLoading(false);
  };

  const handleSelect = (item) => {
    //setQuery(item);
    setResults([]);
    navigate('/product/'+item);
  };

const handleChange = (e) => {
    setQuery(e.target.value);
  };
const toggleMenu = (isOpen) => {
  if(isOpen==true)
    setIsMobileMenuOpen('menu-wrapper flyIn');
  else
    setIsMobileMenuOpen('menu-wrapper');
  };

  return (
<header className="header-block">
    <nav className="main-navbar navbar navbar-default navbar-fixed-top top-nav">
        <div className="container">
            <div className="navbar-wrapper">
                <Link id="logo" className="logo" to="/">
                    <img alt="Cornerstone - Nature, Engineered for Ingredients" src="/assets/images/logo-full.png"/>
                    </Link>
                <div className={isMobileMenuOpen}>
                    <button className="closeIn"  onClick={() => toggleMenu(false)}></button>
                    <ul id="top-menu" className="navbar-list main-nav-list">
                    <li id="menu0" className={`level-1 menu-item menu-item-type-custom menu-item-object-custom ${activeMenu === 'menu0' ? 'active' : ''}`} onMouseEnter={() => setActiveMenu("menu0")}
          onMouseLeave={() => setActiveMenu(null)}><Link  to="/" onClick={() => toggleMenu(false)}>Home</Link></li>
                        <li id="menu1" className={`level-1 menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children  ${activeMenu === 'menu1' ? 'active' : ''}`} onMouseEnter={() => setActiveMenu("menu1")}
          onMouseLeave={() => setActiveMenu(null)}>
                            <a className="dropdown-trigger" href="#">CORPORATE</a>
                            <ul className="sub-menu">
                                <li id="menu-item-130" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-130">
                                    <Link className="dropdown-trigger" to="/about/overview" onClick={() => toggleMenu(false)}>OVERVIEW</Link>
                                </li>
                                <li id="menu-item-130" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-130">
                                    <Link className="dropdown-trigger" to="/about/vision" onClick={() => toggleMenu(false)}>VISION & MISSION</Link>
                                </li>
                                <li id="menu-item-130" className="menu-item menu-item-type-custom menu-item-object-custom  menu-item-130">
                                    <Link className="dropdown-trigger" to="/about/values" onClick={() => toggleMenu(false)}>VALUES</Link>
                                </li>
                                <li id="menu-item-130" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-130">
                                    <Link className="dropdown-trigger" to="/about/team" onClick={() => toggleMenu(false)}>OUR TEAM</Link>
                                </li>
                                <li id="menu-item-130" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-130">
                                    <Link className="dropdown-trigger" to="/about/milestones" onClick={() => toggleMenu(false)}>MILSTONES</Link>
                                </li>
                            </ul>
                        </li>
                        <li id="menu2" className={`level-1 menu-item menu-item-type-custom menu-item-object-custom ${activeMenu === 'menu2' ? 'active' : ''}`} onMouseEnter={() => setActiveMenu("menu2")}
          onMouseLeave={() => setActiveMenu(null)}>
                            <a className="dropdown-trigger" href="#">Expertise</a>
<ul className="sub-menu">
                                <li id="menu-item-130" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-130">
                                    <Link className="dropdown-trigger" to="/expertise/steam-distillation" onClick={() => toggleMenu(false)}>STEAM DISTILLATION</Link>
                                </li>
                                {/* <li id="menu-item-130" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-130">
                                    <Link className="dropdown-trigger" to="/expertise/solvent-extraction">SOLVENT EXTRACTION</Link>
                                </li>
                                <li id="menu-item-130" className="menu-item menu-item-type-custom menu-item-object-custom  menu-item-130">
                                    <Link className="dropdown-trigger" to="/expertise/fractional-distillation">FRACTIONAL DISTILLATION</Link>
                                </li> */}
                                <li id="menu-item-130" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-130">
                                    <Link className="dropdown-trigger" to="/expertise/supercritical-co2-extraction" onClick={() => toggleMenu(false)}>SUPERCRITICAL CO2 EXTRACTION</Link>
                                </li>
                               
                            </ul>
                        </li>
                       
                        <li id="menu3" className={`level-1 menu-item menu-item-type-custom menu-item-object-custom ${activeMenu === 'menu3' ? 'active' : ''}`} onMouseEnter={() => setActiveMenu("menu3")}
          onMouseLeave={() => setActiveMenu(null)}>
                            <a className="dropdown-trigger" href="#">Products</a>
                          
                             <ul className="sub-menu">

                                 {menuData.map((item) => (
                                <MenuItem key={item.id} item={item} closemenu={() => toggleMenu(false)} />
                                ))}
                            </ul>
                        </li>
                        <li id="menu4" className={`level-1 menu-item menu-item-type-custom menu-item-object-custom ${activeMenu === 'menu4' ? 'active' : ''}`} onMouseEnter={() => setActiveMenu("menu4")}
          onMouseLeave={() => setActiveMenu(null)}>
                            <a className="dropdown-trigger" href="#">Applications</a>
                             <ul className="sub-menu">
                              {applicationData.map((item) => (
                                <ApplicationMenuItem key={item.id} item={item}  closemenu={() => toggleMenu(false)}/>
                                ))} 
                            </ul>
                        </li>
                       
                    </ul>
                </div>
                <button className="hamburger" onClick={() => toggleMenu(true)}></button>
            </div>
        </div>
    </nav>



    <nav className="sub-nav navbar navbar-default" id="top">
        <div className="container">
            <div className="sub-nav-wrapper">

                <ul id="top-menu" className="navbar-list sub-nav-list second-menu">
                    {/* <li id="menu-item-175" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-175">
                        <Link className="dropdown-trigger" to="/blogs">OUR BLOG</Link>
                    </li> */}
                    {/* <li id="menu-item-2585" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2585"><a className="dropdown-trigger" href="work-at-manekancor/benefits-of-joining.html">CAREER</a></li> */}
                    <li id="menu-item-177" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-177"><Link className="dropdown-trigger" to="/contactus">CONTACT US</Link></li>
                </ul>
                <div>
                <input type="text" value={query}
        onChange={handleChange}
 className="predictive__search--input"  id="searchTerm" 
                placeholder="Search Product"  autocomplete="off" />
                    <button className="predictive__search--button"  aria-label="search button" type="button"><svg className="header__search--button__svg" xmlns="http://www.w3.org/2000/svg" style={{color:"white"}} width="30.51" height="25.443" viewBox="0 0 512 512"><path d="M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></path><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M338.29 338.29L448 448"></path></svg>  </button>
                  {/* {isLoading && <p>Loading...</p>} */}
      {results.length > 0 && (
       
        <ul style={{ listStyle: 'none', margin: 0, padding: '0 8px', border: '1px solid #ccc', position: 'absolute', width: '100%', background: 'white', zIndex: 1 }}>
            {results.map((item, index) => (
            <li
              key={index}
              onClick={() => handleSelect(item.url)}
              style={{ padding: '5px 0', cursor: 'pointer' }}
            >
               {item.name} 
                </li>
          ))}
        </ul>
      )}    
    </div>
        </div>
        </div>
    </nav>

</header>
  );
};

export default Header;